import React from "react";
import useFetchQlpConsumables from "../../Hooks/qlp_ddpcr/useFetchQlpConsumables";
import { useParams } from "react-router-dom";


const QlpConsumables = () => {

    const { plate_uuid } = useParams();

    const qlpData = useFetchQlpConsumables(plate_uuid);
    const consumables = qlpData?.data?.data;

    return (
        <>
            {
                qlpData?.isSuccess && consumables ?
                    (<div className='flex gap-x-4 *:font-semibold'>
                        <span>Software Version:</span>{consumables["Software Version"]}
                        <span>Reader:</span>{consumables["Reader"]}
                        <span>Operator:</span>{consumables["Operator"]}
                        <span>Type:</span>{consumables["Type"]}
                        <span>Date/Time:</span>{consumables["Date/Time"]}
                    </div>
                    ) : qlpData?.isLoading ?
                        (<div className='text-custom-green font-bold'>Loading...</div>) :
                        (<div className='text-red-700'>Error</div>)
            }
        </>
    );
}

export default QlpConsumables;